<div class="modal-header">
  <h4 class="modal-title" id="modal-title"><i [class]="icon" class="fa-fw me-2"></i>{{ title }}</h4>
  <button type="button" class="btn-close bg-secondary" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="modal-body">
  <span class="fw-semibold" style="white-space: pre-wrap">{{ message }}</span>
</div>
<div class="modal-footer">
  <button
    type="button"
    ngbAutofocus
    class="btn"
    [class]="{ 'btn-danger': style === 'danger', 'btn-success': style !== 'danger' }"
    (click)="confirm()">
    {{ confirmBtnText }}
  </button>
  <button type="button" class="btn btn-outline-secondary" (click)="dismiss()">Close</button>
</div>
